import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { SBW_TIMEOUT } from '../constants/common.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { PredictiveSearchResponse } from '../models/core-apis/predictive-search.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PredictiveSearchService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getPredictiveSearch(
    airportCode: string
  ): Observable<PredictiveSearchResponse> {
    const airportUpperCase = airportCode.toUpperCase();
    return new ApiBuilder<string, PredictiveSearchResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.HEADER)
      .endpointKey(EndpointKeys.APP_NEW_PREDICTIVE_API_URL)
      .queryParams(`/${airportUpperCase}`)
      .method(HttpRequestMethods.GET)
      .timeOut(SBW_TIMEOUT.PE_AE)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
